module.exports = __webpack_public_path__ + "media/images/img-hero-mockup-33a3e73fb7cd88b4c79eac511c56faf7.png";